
<div class="question-container">
  <div class="title">{{ 'App.Questions.' + (activeQuestionIndex + 1) + '.Category' | translate }}</div>
  <div class="description">{{ 'App.Questions.PreQuestionTextNoPriorAnswers' | translate }} {{ 'App.Questions.' + (activeQuestionIndex + 1) + '.Question' | translate }}</div>
  <div class="description-slider">{{ 'WebApp.v1.Survey.SurveySlider.DragSlider' | translate }}</div>
</div>

<div class="answer-container">
  <div class="answer-options">
    @for (option of answerOptions; track option; let i = $index) {
      <div
        class="answer-option"
        [class.active]="i === activeOptionIndex"
      >{{ 'App.Questions.' + (activeQuestionIndex + 1) + '.Option' + (i + 1) | translate }}</div>
    }
  </div>

  <div class="sliders" [style.--active-slider-index]="activeQuestionIndex">
    <div class="caret"></div>
    @if (isMobile) {
      @for (question of survey.questions; track question; let i = $index) {
        <app-slider
          class="slider"
          [class.active]="i === activeSliderIndex"
          [index]="i"
          [numberOfTicks]="answerOptions.length"
          [text]="question.text | translate"
          [icon]="question.icon"
          [active]="i === activeSliderIndex && (sliderClicked || question.answer === -1)"
          [showOutline]="i < activeSliderIndex"
          [finished]="question.answer !== -1"
          (sliderChange)="onSliderChange($event, i)"
          (tickIndexChange)="onTickIndexChange($event)"
          (click)="onSliderClick(i)"
        ></app-slider>
      }
    } @else {
      @for (question of survey.questions; track question; let i = $index) {
        <app-slider
          #sliders
          class="slider"
          [class.active]="i === activeSliderIndex"
          [index]="i"
          [numberOfTicks]="answerOptions.length"
          [text]="question.text | translate"
          [icon]="question.icon"
          [active]="i === activeSliderIndex"
          [showOutline]="i < activeSliderIndex"
          [finished]="question.answer !== -1"
          (sliderChange)="onSliderChange($event, i)"
          (tickIndexChange)="onTickIndexChange($event)"
          (click)="onSliderClick(i)"
        ></app-slider>
      }
    }
  </div>
</div>

@if (isMobile) {
  <div class="carousel-dots">
    @for (dot of survey.questions; track dot; let i = $index) {
      <div 
        class="dot" 
        [class.active]="i === activeSliderIndex"
        [class.disabled]="dot.answer === -1 && i > lastActiveSliderIndex"
        (click)="onCarouselDotClick($index)"
      ></div>
    }
  </div>
}